import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';

interface Props {
  label: string;
  items: any[];
  labelKey: string;
  valueKey: string;
  controllerProps: any;
  errors?: any;
  readOnly?: boolean;
  isRequired?: boolean;
  defaultValue?: any;
  onChange?: (value: any) => void;
}

export function SelectBoxAutocomplete({
  label,
  items,
  labelKey,
  valueKey,
  controllerProps,
  errors,
  readOnly,
  isRequired,
  defaultValue,
  onChange,
}: Props) {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <FormControl fullWidth>
      <Controller
        {...controllerProps}
        render={({ field }) => (
          <>
            <Autocomplete
              {...field}
              clearOnEscape
              options={items}
              getOptionLabel={(option: any) => option[labelKey]}
              // values always match since we are using the same object reference
              isOptionEqualToValue={() => true}
              defaultValue={defaultValue}
              onChange={(e, data) => {
                field.onChange(data ? data[valueKey] : null);
                if (!onChange) return;
                onChange!(data ? data[valueKey] : null);
              }}
              value={
                items.find((x) => x[valueKey] === field.value)
                  ? {
                      [valueKey]: field.value,
                      [labelKey]: items.find((x) => x[valueKey] === field.value)[labelKey],
                    }
                  : null
              }
              open={open}
              onOpen={() => !readOnly && setOpen(true)}
              onClose={() => setOpen(false)}
              disableClearable={readOnly}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    defaultValue={defaultValue}
                    InputProps={{ ...params.InputProps, readOnly, disabled: readOnly }}
                    label={label}
                    error={Boolean(errors[controllerProps.name])}
                    required={isRequired}
                    helperText={errors[controllerProps.name]?.message}
                  />
                );
              }}
            />
          </>
        )}
      />
    </FormControl>
  );
}
